import React from 'react';
import ReactDOM from 'react-dom';
import RootMain from '../containers/RootMain';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

window.jsPDF = jsPDF;
window.html2canvas = html2canvas;

function loadMainApp () {
  ReactDOM.render(<RootMain />, document.getElementById('main-container'));
}

window.loadMainApp = loadMainApp;
